export default __webpack_public_path__ + "static/media/tiktok.cf98af01.svg";